'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileDescription = renderWithRef('StandardTileDescription', null, (o, t)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-standard-tile-description'
        ],
        props: o,
        children: o.children
    }));

export { StandardTileDescription };
